<div class="dialog-content-wrapper" style="margin: -24px;">
  <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
          <span class="title dialog-title">{{translations.lblApiUserDetailsForm}}</span>
          <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
              <mat-icon>close</mat-icon>
          </button>
      </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-24 m-0" fusePerfectScrollbar style="padding-bottom:0px !important;">
    <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblLoggedInUser}}" disabled [value]="userInfo.UserName">
        </mat-form-field>
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblCurrentDateTime}}" disabled [value]="currentTime">
        </mat-form-field>
      </div>
      <mat-divider></mat-divider>
    <form [formGroup]="formGroup" novalidate>
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblApiUserName}}" formControlName="ApiUserName" [(ngModel)]="apiUserDetails.ApiUserName" required maxlength="25">
            <mat-error *ngIf="formGroupErrors.ApiUserName.required">
                {{translations.msgApiUserNameRequired}}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblApiDescription}}" formControlName="ApiDescription" [(ngModel)]="apiUserDetails.ApiDescription" required maxlength="500">
            <mat-error *ngIf="formGroupErrors.ApiDescription.required">
                {{translations.msgApiDescriptionRequired}}
            </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblApiIpAddresses}}" formControlName="ApiIpAddresses" [(ngModel)]="apiUserDetails.ApiIpAddresses" required maxlength="300">
            <mat-error *ngIf="formGroupErrors.ApiIpAddresses.required">
                {{translations.msgApiIpAddressesRequired}}
            </mat-error>
        </mat-form-field>
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblApiKey}}" formControlName="ApiKey" [(ngModel)]="apiUserDetails.ApiKey" readonly="true" maxlength="100" disabled>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="start start">
        <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="47">
            <input matInput placeholder="{{translations.lblLastApiCallDateTime}}" formControlName="LastApiCallDateTime" [(ngModel)]="apiUserDetails.LastApiCallDateTime" readonly="true" maxlength="100" disabled>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="right">
    <button mat-raised-button color="accent" aria-label="SAVE" [disabled]="apiUserDetailsId === 0" (click)="generateApiKey();" fxFlex="47">
        {{translations.btnGenerateApiKey}}
    </button>
    <button mat-raised-button color="accent" aria-label="SAVE" [disabled]="formGroup.invalid" (click)="save();" fxFlex="47">
        {{translations.btnSave}}
    </button>
    <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="47">
        {{translations.btnClose}}
    </button>
</div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/distributor/api-user-details/api-user-details-edit-form/api-user-details-edit-form.component.html